import React from "react"
import Table from "../Component/Table/Table"

function Market() {
  return <Table />
}

export default Market
